// extracted by mini-css-extract-plugin
export var numpadContainer = "_m3-1";
export var phoneButton = "_m3-0";